import { APPLICANT_ATTRIBUTION_BOTH } from 'cpool-constants';
import { z } from 'zod';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#antragstellerzuordnung

	"ANTRAGSTELLER_1" | "ANTRAGSTELLER_2" | "BEIDE"

*/

export const schemaEuropaceAntragstellerzuordnung = z.nativeEnum(APPLICANT_ATTRIBUTION_BOTH);
export type SchemaEuropaceAntragstellerzuordnung = z.infer<typeof schemaEuropaceAntragstellerzuordnung>;
